import { SystemRole } from '@/entities/authentication';
import {
  CheckPersonAccessEventDocument,
  type CheckPersonAccessEventQuery,
  type CheckPersonAccessEventQueryVariables,
} from '@/entities/event';
import { getUserStore } from '@/entities/user';
import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client';
import { redirect } from '@tanstack/react-router';

export async function accessEventGuardRoute({
  eventUuid,
  client,
}: {
  eventUuid: string;
  client: ApolloClient<NormalizedCacheObject>;
}) {
  const user = getUserStore();

  if (
    user?.roleName !== SystemRole.EventAdmin &&
    user?.roleName !== SystemRole.EventUser
  ) {
    return;
  }

  const { data: checkAccessEvent } = await client.query<
    CheckPersonAccessEventQuery,
    CheckPersonAccessEventQueryVariables
  >({
    query: CheckPersonAccessEventDocument,
    variables: {
      input: {
        eventUuid,
      },
    },
  });

  if (!checkAccessEvent?.checkPersonAccessEvent?.accessible) {
    throw redirect({ to: '/events', replace: true });
  }
}
